import { Button, Flex, Icon, TableContainer } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import * as T from '../../../components/Table'
import { ControleIlustracaoList } from './ControleIlustracaoList'
import { FaCloudDownloadAlt } from 'react-icons/fa'
import { FiltroControleIlustracao } from './FiltroControleIlustracao'
import { useControleIlustracaoContext } from '../../../contexts/ControleIlustracaoProvider'

export function ControleIlustracao() {
  const { formValues, isCompreGanhe } = useControleIlustracaoContext()

  const params = isCompreGanhe ? `compre_ganhe=1&modelo_arte=${formValues.modelo_arte}` : `numero_pedido=${formValues.pedido}`

  const linkDownload = `${process.env.REACT_APP_BASE_URL}/site/v2/pedido/gerar-script-ilustracao?${params}`

  return (
    <>
      <HeadingPages name="Controle Ilustração" />

      <Flex flexDir="column" gap={5} maxW="1341px" mx="auto" px={5} mt={5}>
        <Flex alignItems="flex-end" gap={5}>
          <FiltroControleIlustracao />
        </Flex>
        <Flex alignItems="center" gap={3} ml="auto">
          <Button as="a" href={linkDownload} variant="outline" size="sm" leftIcon={<Icon as={FaCloudDownloadAlt} />}>
            Download Fotos e Script
          </Button>

          {/* <ModalUploadFotos /> */}
        </Flex>

        <TableContainer>
          <T.Table>
            <T.Thead>
              <T.Tr>
                <T.Th textAlign="start" px={3}>
                  Produto
                </T.Th>
                <T.Th>Pedido</T.Th>
                <T.Th>
                  Quantidade <br /> por Layout
                </T.Th>
                {/* <T.Th>Nome</T.Th> */}
                <T.Th>Layout</T.Th>
                <T.Th>Modelo Escolhido</T.Th>
                <T.Th />
                <T.Th />
              </T.Tr>
            </T.Thead>
            <T.Tbody>
              <ControleIlustracaoList />
            </T.Tbody>
          </T.Table>
        </TableContainer>
      </Flex>
    </>
  )
}
